"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VIDEO_CARD_FRAGMENT = void 0;
const helpers_1 = require("../../client/helpers");
exports.VIDEO_CARD_FRAGMENT = `
  fragment VideoCardFragment on VideoCard {
    updatedAt
    position
    targetExternalUrl
    showAt
    hideAt
    buttonText
    createdAt
    targetExternalType
    thumbnailUrl
    type
    title
    targetChannelId
    targetVideoId
    id
    targetExternalId
    customOrder
  }
`;
//# sourceMappingURL=fragments.js.map